angular.module('autoremind.templates')
    .directive('imageUiNoCache', function () {
    return {
        scope: true,
        restrict: 'A',
        link: function (scope, elem, attr) {
            console.log('imageUiNoCache');
            var timestamp = new Date().getTime();
            var imgSrc = elem.attr('src');
            if (!imgSrc) {
                return;
            }
            var newSrc = imgSrc;
            if (imgSrc.indexOf('?') === (-1)) {
                newSrc += '?' + timestamp;
            }
            else {
                newSrc += '&' + timestamp;
            }
            elem.attr('src', newSrc);
        }
    };
});
//# sourceMappingURL=image-ui-no-cache.directive.js.map